import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Reveal, Eyebrow } from "../components/Reveal";

const formatDetail = (detail) => {
  if (detail == null) return "Qualcosa non ha funzionato. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail?.msg || detail);
};

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(formatDetail(data.detail));
      localStorage.setItem("artemisia_admin_token", data.token);
      toast.success("Bentornata, Agnese.");
      navigate("/admin");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-3xl bg-cream-dark/60 px-6 py-4 text-sm text-ink placeholder:text-ink/35 outline-none transition-shadow duration-300 focus:shadow-[0_0_0_3px_rgba(79,100,91,0.18)]";

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center px-6 pt-24 pb-16">
      <Reveal className="w-full max-w-md">
        <div className="rounded-[3rem] bg-cream-soft p-10 sm:p-12">
          <Eyebrow>Area Riservata</Eyebrow>
          <h1 className="mt-4 font-serif text-3xl italic" data-testid="admin-login-title">Ciao Agnese</h1>
          <p className="mt-2 text-sm text-ink/60">Accedi per gestire calendario ed eventi.</p>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="mb-2.5 block text-xs font-semibold uppercase tracking-[0.2em] text-ink/50">Email</label>
              <input id="admin-email" type="email" required data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="la tua email" className={inputCls} />
            </div>
            <div>
              <label htmlFor="admin-password" className="mb-2.5 block text-xs font-semibold uppercase tracking-[0.2em] text-ink/50">Password</label>
              <input id="admin-password" type="password" required data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full rounded-full bg-[linear-gradient(135deg,#4F645B,#7A9488)] px-8 py-4 text-sm font-semibold text-cream transition-all duration-500 hover:scale-[1.02] disabled:opacity-60"
            >
              {loading ? "Accesso…" : "Accedi"}
            </button>
          </form>
          <Link to="/" data-testid="admin-back-home" className="mt-6 block text-center text-xs text-ink/40 transition-colors hover:text-sage-deep">
            ← Torna al sito
          </Link>
        </div>
      </Reveal>
    </div>
  );
};

export default AdminLogin;
